import oktaClient from '../libs/oktaClient';
import okta from '../config/okta';
import { Auth } from 'aws-amplify';

import * as types from './types';
import { debugLog } from "../libs/app";

/*
 * Authentication Actions
 */
export const loginUser = () => {
  return async dispatch => {
    dispatch(authRequest());
    // Handle authentication. If token exists, continue otherwise hand off to Okta for authentication
    const result = await oktaClient.handleAuthentication();
    // If authentication was successful or already existed, move on to getting credentials from AWS
    if (await oktaClient.isAuthenticated()) {
      dispatch(authSuccess());
      let user;
      try {
        dispatch(credentialsRequest());
        // Check localstorage for credentials, if they don't exist, get them from AWS
        if(!await Auth.currentCredentials()) {
          await Auth.federatedSignIn(
            okta.oktaDomain,
            {
              token: oktaClient.getIdToken(),
              expires_at: 3600 * 1000 + new Date().getTime()
            },
            oktaClient.getBasicProfile()
          );
        }
        user = await Auth.currentAuthenticatedUser();
      } catch (e) {
        // Likely because we had credentials but they were expired or not set correctly
        debugLog('No User');
      }
      // Something happened above, lets get new credentials
      if (!user) {
        try {
          await Auth.federatedSignIn(
            okta.oktaDomain,
            {
              token: oktaClient.getIdToken(),
              expires_at: 3600 * 1000 + new Date().getTime()
            },
            oktaClient.getBasicProfile()
          );
          user = await Auth.currentAuthenticatedUser();
          debugLog(user);
        } catch (e) {
          // We tried 2 ways, it ain't happening
          dispatch(credentialsFailure(e.message));
          console.error('AWS Error: ', e);
        }
      }
      if (user) {
        dispatch(credentialsSuccess());
        //dispatch(setUser(user));
      }
    } else {
      dispatch(authFailure('Problem Authenticating: ' + result.message));
    }
  }
};

export const authRequest = () => {
  return {
    type: types.AUTH_REQUEST
  }
};

export const authSuccess = () => {
  return {
    type: types.AUTH_SUCCESS
  }
};

export const authFailure = (message) => {
  return {
    type: types.AUTH_FAILURE,
    message
  }
};

export const getCredentials = (idToken, oktaUser) => {
  return async dispatch => {
    // Authentication already handled
    let user;
    try {
      debugLog(oktaUser);
      dispatch(credentialsRequest());
      // Check localstorage for credentials, if they don't exist, get them from AWS
      if(!await Auth.currentCredentials()) {
        await Auth.federatedSignIn(
          okta.oktaDomain,
          {
            token: idToken,
            expires_at: 3600 * 1000 + new Date().getTime()
          },
          {
            name: oktaUser.name,
            email: oktaUser.email,
            deltaId: oktaUser.deltaId
          }
        );
      }
      user = await Auth.currentAuthenticatedUser();
    } catch (e) {
      console.error(e)
      // Likely because we had credentials but they were expired or not set correctly
      debugLog('No User');
    }
    // Something happened above, lets get new credentials
    if (!user) {
      try {
        await Auth.federatedSignIn(
          okta.oktaDomain,
          {
            token: idToken,
            expires_at: 3600 * 1000 + new Date().getTime()
          },
          {
            name: oktaUser.name,
            email: oktaUser.email,
            deltaId: oktaUser.deltaId
          }
        );
        user = await Auth.currentAuthenticatedUser();
      } catch (e) {
      // We tried 2 ways, it ain't happening
        dispatch(credentialsFailure(e.message));
        console.error('AWS Error: ', e);
      }
    }
    if (user) {
      dispatch(credentialsSuccess());
      //dispatch(setUser(user));
    }
  }
};

export const credentialsRequest = () => {
  return {
    type: types.CREDENTIALS_REQUEST
  }
};

export const credentialsSuccess = () => {
  return {
    type: types.CREDENTIALS_SUCCESS
  }
};

export const credentialsFailure = (message) => {
  return {
    type: types.CREDENTIALS_FAILURE,
    message
  }
};

export const logoutUser = () => {
  return async dispatch => {
    dispatch(logoutRequest());
    const result = await oktaClient.handleSignOut();
    if(result.status) {
      try {
        await Auth.signOut();
        dispatch(logoutSuccess());
      } catch (e) {
        console.error(e);
        dispatch(logoutFailure('Problem revoking AWS tokens: ' + e.message));
      }
    } else {
      dispatch(logoutFailure('Problem Signing Out of Okta: ' + result.message));
    }
  }
};

export const logoutRequest = () => {
  return {
    type: types.LOGOUT_REQUEST
  }
};

export const logoutSuccess = () => {
  return {
    type: types.LOGOUT_SUCCESS
  }
};

export const logoutFailure = (message) => {
  return {
    type: types.LOGOUT_FAILURE,
    message
  }
};

export const setUser = (user) => {
  return {
    type: types.SET_USER,
    user
  }
};